import { Options } from '@utils/index'
const options = new Options('performance.rate')
  .add('1', 'rectification')
  .add('2', 'eliminate')

export default options
